import * as React from "react";
import { LogoCloud } from "../atoms/LogoCloud";
import { SectionContainer } from "../layout";
import { Button } from "../atoms/Button";

export const LogoCloudSection = ({
  title,
  description,
  logos,
  button,
  backgroundColor,
}) => {
  return (
    <SectionContainer
      title={title}
      description={description}
      className={backgroundColor}
    >
      <LogoCloud items={logos} />
      {button && <Button className="mt-8" {...button} />}
    </SectionContainer>
  );
};
